import { render, staticRenderFns } from "./SandBox.vue?vue&type=template&id=33dcdfc3&scoped=true"
import script from "./SandBox.vue?vue&type=script&lang=js"
export * from "./SandBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33dcdfc3",
  null
  
)

export default component.exports